import { buildOutline } from './buildOutline'
import { translatePath } from './helper/translatePath'
import { rotatePath } from './helper/rotatePath'
// import { lastPoint } from './helper/lastPoint'
import { mirrorPath } from './helper/mirrorPath'
import { pathA, pathB, pathC, pathD } from './enclosurePaths'
import defaultParameters from '../../defaultConfig'
import { adapterHeadNutSlotWidth } from 'src/constants/parameters'

/*
 *
 *
 */

export const enclosingFrontBack = (
  enclosureWidth: number,
  enclosureHeight: number,
  enclosureThickness: number,
  adapterHeadCornerPositionWidth: number = defaultParameters.adapterHeadCornerPositionWidth,
  adapterHeadSlotWidth: number = adapterHeadNutSlotWidth
) => {
  return buildOutline(
    rotatePath(pathC(enclosureHeight, enclosureThickness, 8), 90),
    mirrorPath(pathD(enclosureWidth, enclosureThickness, adapterHeadCornerPositionWidth, adapterHeadSlotWidth), 'x')
  )
}

/*
 *
 *
 */

export const enclosingRightLeft = (
  enclosureHeight: number,
  enclosureDepth: number,
  enclosureThickness: number,
  adapterHeadCornerPositionWidth: number = defaultParameters.adapterHeadCornerPositionWidth,
  adapterHeadSlotWidth: number = adapterHeadNutSlotWidth
) => {
  // const pc = mirrorPath(
  //   rotatePath(pathC(enclosureDepth, enclosureThickness, adapterHeadCornerPositionWidth, adapterHeadSlotWidth), 90),
  //   'y'
  // )
  // const pa = mirrorPath(
  //   pathA(enclosureHeight, enclosureThickness, adapterHeadCornerPositionWidth, adapterHeadSlotWidth),
  //   'x'
  // )
  const generated = buildOutline(
    mirrorPath(rotatePath(pathC(enclosureDepth, enclosureThickness, 8), 90), 'y'),
    mirrorPath(pathA(enclosureHeight, enclosureThickness, adapterHeadCornerPositionWidth, adapterHeadSlotWidth), 'x')
  )

  return translatePath(generated, [enclosureThickness, 0])
}

/*
 *
 *
 */

export const enclosingTopBottom = (
  enclosureWidth: number,
  enclosureDepth: number,
  enclosureThickness: number,
  adapterHeadCornerPositionWidth: number = defaultParameters.adapterHeadCornerPositionWidth,
  adapterHeadSlotWidth: number = adapterHeadNutSlotWidth
) => {
  return buildOutline(
    mirrorPath(
      rotatePath(pathB(enclosureDepth, enclosureThickness, adapterHeadCornerPositionWidth, adapterHeadSlotWidth), 90),
      'y'
    ),
    pathA(enclosureWidth, enclosureThickness, adapterHeadCornerPositionWidth, adapterHeadSlotWidth),
    [enclosureThickness, enclosureThickness]
  )
}

/*
 *
 *
 */

export {
  pathC as enclosingFrontBackX,
  pathD as enclosingFrontBackY,
  pathC as enclosingRightLeftY,
  pathA as enclosingRightLeftX,
  pathB as enclosingTopBottomX,
  pathA as enclosingTopBottomY
}
